var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exchange-layout __flex_row" }, [
    _c("div", { staticClass: "left __flex_column" }, [
      _c("div", { staticClass: "t __border" }, [_vm._t("lb1")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "b __border" }, [_vm._t("lb3")], 2)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "center __flex_column" }, [
      _c("div", { staticClass: "t __flex_column __border" }, [
        _c("div", { staticClass: "t-t" }, [_vm._t("lt")], 2),
        _vm._v(" "),
        _c("div", { staticClass: "c" }, [_vm._t("lb2")], 2)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "b __border" }, [_vm._t("lb4")], 2)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right __border" }, [_vm._t("r")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }